export function isImageData(frame) {
    return 'data' in frame && frame.data instanceof Uint8ClampedArray;
}
/** Converts a browser VideoFrame to ImageData without mutating or closing the source frame. */
export async function frameToImageData(frame) {
    if (isImageData(frame))
        return frame;
    const width = frame.displayWidth || frame.codedWidth;
    const height = frame.displayHeight || frame.codedHeight;
    if (width <= 0 || height <= 0)
        throw new Error('PCE frame dimensions must be positive.');
    if (typeof OffscreenCanvas !== 'undefined') {
        const canvas = new OffscreenCanvas(width, height);
        const context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context)
            throw new Error('PCE could not create an offscreen 2D context.');
        context.drawImage(frame, 0, 0, width, height);
        return context.getImageData(0, 0, width, height);
    }
    if (typeof document !== 'undefined') {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context)
            throw new Error('PCE could not create a 2D context.');
        context.drawImage(frame, 0, 0, width, height);
        return context.getImageData(0, 0, width, height);
    }
    throw new Error('VideoFrame conversion requires a browser canvas implementation.');
}
//# sourceMappingURL=frame.js.map